const Backbone = require('lib/backbone')
const Marionette = require('lib/marionette')
const _ = require('lib/underscore')
const Element = require('../model/element.base')
const InputAttributes = require('./input_attributes')


const InputSelectOptionView = Marionette.View.extend({

    displayName: 'InputSelectOptionView',
    tagName: 'option',
    template: _.template('{{ data.label }}'),
    attribute_keys: ['value', 'disabled', 'selected'],
})

_.extend(InputSelectOptionView.prototype, InputAttributes)


const InputSelectView = Marionette.CollectionView.extend({

    displayName: 'InputSelectView',

    tagName: 'select',

    childView: InputSelectOptionView,
    childViewOptions() {
        return {
            selected: this.model.get('value'),
        }
    },

     
    constructor: function constructor(options) {
        // validate model
        if (! (options.model instanceof Element)) throw new Error('InputView requires an Element model.')

        options.collection = options.model.get('values')

        Marionette.CollectionView.call(this, options)

        // listen for external changes to the model
        this.listenTo(this.model, 'change:value', this.onModelChangeValue)

        // these steps allow the view to consume an existing dom element
        this.listenTo(this, 'render', this.setAttributes)
        this.listenTo(this, 'render', this.showPlaceholder)
        this.listenTo(this, 'destroy:children', this.showPlaceholder)
        const className = this.model.get('className')
        if (className) this.$el.addClass(className)
    },

    attribute_keys: ['id', 'name', 'disabled'],

    triggers: {
        'change': 'input:change',
    },

    showPlaceholder() {
        // add placeholder option
        if (this.model.get('placeholder')) {
            const placeholder = new Backbone.Model({
                value: '',
                label: this.model.get('placeholder'),
                disabled: true,
            })
            // eslint-disable-next-line new-cap
            const view = new this.childView({
                model: placeholder,
            })
            this.addChildView(view, 0)
        }
    },

    onInputChange() {
        const value = this.getInputValue()
        this.model.set('value', value, { from: this })
    },

    getInputValue() {
        return this.$el.val()
    },
    setInputValue(value) {
        return this.$el.val(value)
    },

    onModelChangeValue(model, value, options) {
        if (options.from !== this) {
            this.$el.val(value)
        }
    },
})

// apply methods from InputAttributes mixin
_.extend(InputSelectView.prototype, InputAttributes)

module.exports = InputSelectView
